import { FeeOptionEntity } from 'Models/Entities';
import { bookingType, wizardModes } from 'Models/Enums';
import { tripSummaryLocationType } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/TripBookingSummaryCard';

export function GetFilteredFees(
	fees: FeeOptionEntity[],
	tripSummaryLocation: tripSummaryLocationType,
	wizardMode: wizardModes,
	transactionFeeIdsAlreadyApplied: string[],
	bookingTypes?: bookingType[],
) {
	return fees
		?.filter(x => x.applyForStaff)
		?.filter(x => !x.disabled)
		?.filter(x => transactionFeeIdsAlreadyApplied?.includes(x.id) === false)
		?.filter(x => {
			return tripSummaryLocation === 'check-in' ? x.checkInFee : x.bookingWizardFee;
		})
		?.filter(x => {
			return wizardMode === 'ALTERATION' ? x.alterBookingFee : x.newBookingFee;
		})
		?.filter(x => {
			if (bookingTypes) {
				if (bookingTypes.includes('VEHICLE') && x.vehicleBooking) {
					return true;
				}
				if (bookingTypes.includes('PASSENGER_ONLY') && x.passengerBooking) {
					return true;
				}
				if (bookingTypes.includes('FREIGHT') && x.freightBooking) {
					return true;
				}
				return false;
			}
			return true;
		});
}
